import React from 'react';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { FormControl, FormHelperText } from '@material-ui/core';
import format from 'date-fns/format';
import frLocale from 'date-fns/locale/fr';
import DateFnsUtils from '@date-io/date-fns';

class FrLocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText(date) {
    return format(date, 'd MMM yyyy', { locale: this.locale });
  }
}

const localeMap = {
  fr: frLocale,
};

const localeUtilsMap = {
  fr: FrLocalizedUtils,
};

const localeFormatMap = {
  fr: 'd MMM yyyy',
};

export default function DatePicker({
  name,
  label,
  value,
  error = null,
  disabled = false,
  onChange,
}) {
  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <MuiPickersUtilsProvider utils={localeUtilsMap.fr} locale={localeMap.fr}>
      <FormControl variant='outlined' {...(error && { error: true })}>
        <KeyboardDatePicker
          disableToolbar
          variant='inline'
          inputVariant='outlined'
          label={label}
          format={localeFormatMap.fr}
          openTo='year'
          name={name}
          value={value}
          disabled={disabled}
          invalidDateMessage='Date incorrecte'
          onChange={(date) => onChange(convertToDefEventPara(name, date))}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </MuiPickersUtilsProvider>
  );
}
